import type {
  JobAreaAccuracy,
  JobDefinition,
  LearningAccelerationReport,
} from '../shared/desktop-api';
export function jobLearningAIQ(
  _job: JobDefinition,
  _areas: readonly JobAreaAccuracy[],
  acceleration: Pick<LearningAccelerationReport, 'capability'>,
) {
  const capability = acceleration.capability;
  if (
    capability?.version === 2 &&
    Number.isFinite(capability.score) &&
    capability.score >= 80 &&
    capability.score <= 165
  ) {
    return {
      score: capability.score,
      evidence: capability.coverage,
      measuredAreas: capability.areas.length,
    };
  }
  return null;
}
